module.exports = __webpack_public_path__ + "static/dl1_full-ffa1b4d5a6141837fdb11f4c571d5411.jpg";